import { ManagerRolesActions, ManagerRolesActionTypes } from '@appStore/managers/actions/manager-roles.actions';
import { ClientRole } from '@model';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: ClientRole[];
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: []
};

export function reducer(state = initialState, action: ManagerRolesActions): State {
  switch (action.type) {
    case ManagerRolesActionTypes.ManagerRolesLoadData:
      return { ...state, loading: true, loaded: false };
    case ManagerRolesActionTypes.ManagerRolesLoadSuccess:
      return { ...state, data: action.payload, loading: false, loaded: true };
    case ManagerRolesActionTypes.ManagerRolesLoadFail:
      return { ...state, data: [], loading: false, loaded: false };
  }
  return state;
}

export const getManagerRoles = (state: State) => state.data;
export const getManagerRolesLoading = (state: State) => state.loading;
export const getManagerRolesLoaded = (state: State) => state.loaded;
